import { Component, OnInit } from '@angular/core';
import { ChipCheckerResults, PetService } from 'src/app/services/pet/pet.service';

@Component({
  selector: 'app-footer-cards',
  templateUrl: './footer-cards.component.html',
  styleUrls: ['./footer-cards.component.scss']
})
export class FooterCardsComponent implements OnInit {
  chipCheckerLoading = false;
  chipCheckerResults: ChipCheckerResults = null;
  chipCheckerNumber: string;

  constructor(
    private petService: PetService,
  ) {}

  checkChip() {
    this.chipCheckerLoading = true;
    this.chipCheckerResults = null;
    this.petService.checkChip(this.chipCheckerNumber)
      .subscribe(
        results => {
          this.chipCheckerResults = results;
        }
      )
      .add(() => {
        this.chipCheckerLoading = false;
      });
  }

  ngOnInit(): void {}
}
